import { useEffect, useState } from "react";
import { MatrixService } from "@hub/services/challenges/matrix.service";
import { FollowJwtRabbitStatus } from "@hub/models/challenges/matrix";

export const useGameStatus = () => {
  const [currentStatus, setCurrentStatus] = useState<FollowJwtRabbitStatus>(
    FollowJwtRabbitStatus.UNKNOWN
  );

  useEffect(() => {
    const gameStatusSubscription = MatrixService.$gameStatus.subscribe(
      (data) => {
        if (data) {
          setCurrentStatus(data);
        }
      }
    );

    return () => {
      if (gameStatusSubscription) {
        gameStatusSubscription.unsubscribe();
      }
    };
  }, []);

  const isNotBuilt = () => currentStatus === FollowJwtRabbitStatus.NOT_BUILT;
  const isNotStarted = () =>
    currentStatus === FollowJwtRabbitStatus.NOT_STARTED;
  const isInProgress = () => currentStatus === FollowJwtRabbitStatus.WIP;
  const isComplete = () => currentStatus === FollowJwtRabbitStatus.COMPLETE;
  const isBlocked = () => currentStatus === FollowJwtRabbitStatus.BLOCKED;
  const isNotReady = () => isNotBuilt() || isNotStarted();

  return {
    currentStatus,
    isNotBuilt,
    isNotStarted,
    isInProgress,
    isComplete,
    isNotReady,
    isBlocked,
  };
};
